<template>
  <div>
    <div class="login_info" v-loading="btnLoading">
      <!--手机号-->
      <div class="form_item">
        <p>{{$t('m.phone')}}</p>
        <div class="form_inputbox">
          <div class="seledArea" @click.stop="showCountryFun">
            <img class="flag_icon" :src="selCountry.logo">
            <span class="fc-pad-lr-min">+{{selCountry.countryNum}}</span>
            <img class="select_icon" :src="(showCountry && $store.state.isShowSelArea)?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
          </div>
          <input class="login_input" type="text" v-model.trim="mobile" oninput="value=value.replace(/\D/g,'')" minlength="6" :placeholder="$t('m.user_enter_bind_phone')" autocomplete="off"/>
          <div class="selarea_box" v-if="showCountry && $store.state.isShowSelArea">
            <sel-area @countryOption="countryOptionFun"/>
          </div>
        </div>
      </div>
      <!--密码-->
      <div class="form_item">
        <p>{{$t('m.passwd')}}</p>
        <div class="form_inputbox">
          <input class="login_input smscode_input" type="password" v-model.trim="passwd" maxlength="20" minlength="6" :placeholder="$t('m.passwd_placeholder')" autocomplete="off"/>
        </div>
      </div>
      <!--公会长id-->
      <div class="form_item">
        <p>{{$t('m.agency_head_ID')}}</p>
        <div class="form_inputbox">
          <input class="login_input smscode_input" type="text" v-model.trim="userId" oninput="value=value.replace(/\D/g,'')" maxlength="10" :placeholder="$t('m.bc_user_id_tip')" />
        </div>
      </div>
      <!--图片验证码-->
      <div class="form_item">
        <p>{{$t('m.vericode')}}</p>
        <div class="form_inputbox">
          <input class="login_input smscode_input" type="text" v-model.trim="picCode" maxlength="6" :placeholder="$t('m.input_vericode')" />
          <div class="code-pic-box" v-loading="picLoading" @click="refreshPicCode">
            <el-image :src="captcha" class="code-pic">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
      </div>
      <!--注册按钮-->
      <div class="fc-flex-center">
        <div class="login_btn" @click="userRegister">{{$t('m.reg')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mobilePwdRegister, picCaptcha} from "@/api/login/login";
  import {getCountryMsg} from "@/api/common";
  import SelArea from '../../components/SelArea';
  import {isMobileValid} from "@/utils/coding-utils";
  export default {
    name: "regTab",
    components: {SelArea},
    props:{
      agreeXieyi: {
        type: Boolean,
        default () {
          return false;
        }
      },
    },
    data() {
      return {
        picLoading: false,
        captcha: '',
        selCountry:{},
        showCountry: false,
        mobile: null,
        userId: null,
        passwd: null,
        btnLoading: false,
        picCode: null,
        t: null,
      }
    },
    methods: {
      refreshPicCode() {
        this.captcha = ''
        if(this.picLoading) {
          return
        }
        this.getPicCaptcha()
      },
      /**
       * 获取图片验证码
       */
      getPicCaptcha() {
        // 图片加载
        this.picLoading = true
        // 异步获取图片
        let t = Math.random().toString(16).slice(2)
        this.t = t
        picCaptcha(t).then(data => {
          this.captcha = window.URL.createObjectURL(data.data)
        }).catch((data) => {
        }).finally(() => {
          this.picLoading = false
        })
      },
      showTab() {
        this.mobile = null
        this.passwd = null
        this.getPicCaptcha()
        this.getCountryMsgFun()
      },
      /**
       * 账号密码注册
       */
      userRegister() {
        if(this.btnLoading) {
          return
        }

        if(!this.agreeXieyi){
          this.$message.error(this.$t('m.agree_agreement'));
          return false;
        }
        if (!isMobileValid(this.mobile)) {
          this.$message.error(this.$t('m.check_phone_istrue'));
          return false;
        }
        if (this.passwd == null || this.passwd.length < 6 || this.passwd.length > 20) {
          this.$message.error(this.$t('m.passwd_placeholder'));
          return false;
        }
        if(this.userId == null || this.userId.length === 0 || this.userId.length > 10 || this.userId < 0 || this.userId > 2147483647) {
          this.$message.error(this.$t('m.agency_ID_input'));
          return false;
        }
        if(this.picCode == null || this.picCode.length === 0) {
          this.$message.error(this.$t('m.vericode_error'));
          return false;
        }

        this.btnLoading = true
        const data = {
          mobile: this.mobile,
          areaCode: this.selCountry.countryNum,
          passwd: this.passwd,
          userId: this.userId,
          lang: this.$i18n.locale,
          picCode: this.picCode,
          t: this.t
        }
        mobilePwdRegister(data).then(({data}) => {
          // 状态 0：正常， 1：手机号已绑定 2：公会长已绑定 3: 请勿频繁操作 4: 其它错误 5:公会长不存在 6:公会长不处于正常状态 7:密码格式不对 8:已经是公会主播 9: 申请签约主播中
          if(data.data.state === 0) {
            this.$store.commit('setUser', data.data);
            if(data.data.status===3){
              //已入驻
              this.$router.push({
                path: '/guild/my-guild-detail'
              });
            }else{
              //0未申请入驻 1入驻申请未通过
              this.$router.push({
                name: 'apply-index',
                params:{
                  userStatus:data.data.status,
                  stepActive: data.data.status === 0 ? 0 : 2,
                },
                query: {
                  inviteCode: this.$route.query.inviteCode
                }
              });
            }
          } else if(data.data.state === 1) {
            this.$message.error(this.$t('m.phone_bind_error'));
          } else if(data.data.state === 2 || data.data.state === 5 ) {
            this.$message.error(this.$t('m.bc_user_id_error'));
          } else if(data.data.state === 3 || data.data.state === 4) {
            this.$message.error(this.$t('m.network_busy'));
          } else if(data.data.state === 6) {
            this.$message.error(this.$t('m.user_frozen'));
          } else if(data.data.state === 7) {
            this.$message.error(this.$t('m.passwd_placeholder'));
          } else if(data.data.state === 8) {
            this.$message.error(this.$t('m.sign_anchor_error'));
          } else if(data.data.state === 9) {
            this.$message.error(this.$t('m.apply_anchor_error'));
          } else if(data.data.state === 10) {
            this.$message.error(this.$t('m.vericode_error'));
          } else if(data.data.state === 11) {
            this.$message.error(this.$t('m.code_expire'));
          } else if(data.data.state === 12) {
            this.$message.error(this.$t('m.btrade_err'));
          }
        }).catch(() => {}).finally(() => {
          this.btnLoading = false
        })
      },
      /**
       * 更新验证码
       */
      updatePicCaptcha() {
        this.picCode = null
        this.getPicCaptcha()
      },
      //获取默认区号
      getCountryMsgFun(){
        getCountryMsg().then(({data}) =>{
          this.selCountry=data.result;
        })
      },
      countryOptionFun(val){
        this.selCountry = val;
        this.showCountry = false;
      },
      /**
       * 显示区号下拉列表
       */
      showCountryFun(){
        if(this.showCountry && this.$store.state.isShowSelArea){
          this.showCountry = false;
          this.$store.state.isShowSelArea = false;
        }else{
          this.$store.state.isShowSelArea=true;
          this.showCountry = true;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .image-slot{
    width: 100%;
    height: 100%;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*background: #f5f7fa;*/
    /*color: #909399;*/
    /*font-size: 14px;*/
    /*border:1px solid #999595;*/
  }
  .sendcode_box{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f3f3f3;
    .login_input{
      flex: 1;
    }
  }

  input::-ms-input-placeholder {
    font-size: .18rem;
    color: #999;
  }
  input::-webkit-input-placeholder {
    font-size: .18rem;
    color: #999;
  }
  .box{font-size: .14rem;}
  input {
    outline: none;
  }
  .login {
    &_title {
      font-size: .36rem;
      text-align: center;
      padding:.67rem 0 .48rem;
      &_sm {
        font-size: .3rem;
        margin-bottom: .4rem;
      }
    }
    &_info {
      .form_item {
        margin-top: .32rem;
        position: relative;
        p{
          font-size: .18rem;
        }
      }
      .login_input {
        width: 100%;
        height: .54rem;
        font-size: .18rem;
        line-height: .3rem;
        border: none;
        padding: .1rem 0;
        box-sizing: border-box;
        background-color: transparent;
        color: #333;
      }
      .code-pic-box{
        border:1px solid #999595;
        cursor: pointer;
      }
      .code-pic{
        width: 1.3rem;
        height: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f7fa;
        color: #909399;
        font-size: 14px;
      }
    }
    &_btn{
      min-width: 1.8rem;
      max-width: 3rem;
      min-height: .28rem;
      padding: .1rem;
      font-size: .18rem;
      color: #fff;
      text-align: center;
      background-color: #008AFF;
      border-radius: .4rem;
      margin: .2rem auto 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .form_inputbox{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #cdc8c8;
    position: relative;
    span{
      font-size: .18rem;
      // color: #888;
    }
    input{
      flex: 1;
      // padding-left: 1em !important;
      border:none !important;
    }
  }

  @media only screen and (max-width: 767px) {
    .login_title{
      padding: .38rem 0 .18rem;
      font-size: .4rem;
      &_sm{
        font-size: .32rem;
        margin-bottom: 0;
      }
    }
    .login_info {
      margin-bottom: .4rem;
      .login_input{
        border-color: #e4e4e4;
      }
      .form_item{
        margin-top:.32rem;
      }
    }
    .login_btn{
      min-width: 3.2rem;
      max-width: 5rem;
    }
    .login_btn,.login_info .form_item p,.login_info .login_input,.changetxt{
      font-size: .26rem !important;
    }
    .form_inputbox{
      border-color: #e4e4e4;
      span{
        font-size: .26rem;
      }
    }
  }

  @media only screen and (max-width: 540px) {
    input::-ms-input-placeholder {
      font-size: .24rem;
    }
    input::-webkit-input-placeholder {
      font-size: .24rem;
    }
    .login_input {
      font-size: .24rem !important;
    }
    .code-pic-box{
      border:1px solid #999595;
    }
    .code-pic{
      width: 1.3rem;
      height: 0.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/regTab.vue